// src/components/common/DepartmentAccordion.jsx
import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown } from "lucide-react";
import PersonCard from "./PersonCard"; 

const DepartmentAccordion = ({ dept }) => {
  const [isExpanded, setIsExpanded] = useState(true);
  const gridVariants = { hidden: { opacity: 0 }, visible: { opacity: 1, transition: { staggerChildren: 0.05 } } };
  const cardVariants = { hidden: { y: 20, opacity: 0 }, visible: { y: 0, opacity: 1, transition: { type: "spring", stiffness: 300, damping: 20 } } };

  return (
    <div className="department-section">
      <h2 className="department-title clickable-header" onClick={() => setIsExpanded(!isExpanded)}>
        <span>{dept.name}</span>
        <motion.div animate={{ rotate: isExpanded ? 0 : -90 }} transition={{ duration: 0.2 }}>
          <ChevronDown size={24} />
        </motion.div>
      </h2>
      <AnimatePresence>
        {isExpanded && (
          <motion.div initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: "auto" }} exit={{ opacity: 0, height: 0 }} transition={{ duration: 0.3 }} style={{ overflow: "hidden", padding:"12px" }}>
            <motion.div className="leader-grid" variants={gridVariants} initial="hidden" animate="visible">
              {(dept.leaders || []).map((leader, idx) => (
                <motion.div key={leader._id || idx} variants={cardVariants}>
                  {/* Each leader is rendered with the common PersonCard */}
                  <PersonCard personData={{ ...leader, department: dept.name }} />
                </motion.div>
              ))}
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default DepartmentAccordion;